import {connect} from 'react-redux';
import {utils, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import OrderPage from "./OrderPage";
import PlatbaForm from "../../../forms/PlatbaForm";
import * as localStorageUtils from "../../../utils/localStorageUtils";
import {withRouter} from "react-router";
import {redirectToOrderStepNumber} from "../../../utils/utils";
import * as ciselnikActions from "../../../actions/ciselnikActions";
import * as subjektActions from "../../../actions/subjektActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import * as uzivatelActions from "../../../actions/uzivatelActions";
import * as opravneniActions from "../../../actions/opravneniActions";
import {SubmissionError} from "redux-form";
import {withTranslation, WithTranslation} from "react-i18next";

const CURRENT_STEP = 4;

/**
 * Stránka procesu objednávky - Platba.
 */
class PlatbaPage extends Component<WithTranslation> {

    unsavedData = null;

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    componentWillUnmount() {
        const {loggedInUser} = this.props;
        if (this.unsavedData) {
            this.saveData(this.unsavedData);
            this.props.dispatch(objednavkaActions.invalidateDataPlatba());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        }
    };

    fetchData = () => {
        const {loggedInUser, aktivniSpolecnostId, dopravaData, zakaznikData} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            const loggedInUserId = loggedInUser.data.id;
            this.props.dispatch(objednavkaActions.fetchDataZakazkaIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchDataZakaznikIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchDataDopravaIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchDataPlatbaIfNeeded(loggedInUserId));
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUserId));
            if (aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching) {
                this.props.dispatch(subjektActions.fetchUzivatelVychoziHodnotyIfNeeded(loggedInUserId, aktivniSpolecnostId.data));
            }
        }
        // Pokud máme data dopravy, donačteme z nich dopravu, termín dopravy a pobočku
        if (dopravaData.fetched && !dopravaData.isFetching && dopravaData.data) {
            const {naPobocku, pobockaId, zpusobDopravaId, terminDopravaId} = dopravaData.data;
            if (naPobocku) {
                this.props.dispatch(ciselnikActions.fetchPobockaIfNeeded(pobockaId));
            } else { // na adresu
                if (zpusobDopravaId) {
                    this.props.dispatch(ciselnikActions.fetchZpusobDopravyIfNeeded(zpusobDopravaId));
                    if (terminDopravaId) {
                        this.props.dispatch(ciselnikActions.fetchTerminDopravyIfNeeded(zpusobDopravaId, terminDopravaId));
                    }
                }
            }
        }
        // Pokud máme zvolenou aktivní společnost, donačteme její detail
        if (aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching && aktivniSpolecnostId.data) {
            this.props.dispatch(subjektActions.fetchAktivniSpolecnostDetailIfNeeded(aktivniSpolecnostId.data));
        }
        // Pokud z kroku Zákazník máme uživatele (tj. jsem operátor), musíme načíst data (detail a společnost) pro tohoto uživatele
        if (zakaznikData.fetched && zakaznikData.data && zakaznikData.data.uzivatelASpolecnost) {
            const uzivatelId = zakaznikData.data.uzivatelASpolecnost.uzivatelId;
            const spolecnostId = zakaznikData.data.uzivatelASpolecnost.spolecnostId;
            this.props.dispatch(objednavkaActions.fetchObjednavkaUzivatelVychoziHodnotyIfNeeded(uzivatelId, spolecnostId));
            if (spolecnostId) {
                this.props.dispatch(objednavkaActions.fetchObjednavkaSpolecnostIfNeeded(spolecnostId));
            }
        }
    };

    isFetched = () => {
        const {loggedInUser, aktivniSpolecnostId, aktivniSpolecnostDetail, zpusobyPlatbyList, zpusobDoprava,
            pobockaDetail, zakazkaData, zakaznikData, dopravaData, platbaData,
            objednavkaSpolecnostDetail, firmaDetail, terminDopravaDetail, uzivatelVychoziHodnotyDetail,
            objednavkaUzivatelVychoziHodnotyDetail} = this.props;

        const uzivatelUrcenOperatorem = zakaznikData.fetched && !zakaznikData.isFetching && zakaznikData.data && zakaznikData.data.uzivatelASpolecnost;
        const uzivatelSpolecnostId = uzivatelUrcenOperatorem && zakaznikData.data.uzivatelASpolecnost.spolecnostId;

        return loggedInUser.fetched && !loggedInUser.isFetching
            && zpusobyPlatbyList.fetched && !zpusobyPlatbyList.isFetching
            && zakazkaData.fetched && !zakazkaData.isFetching
            && zakaznikData.fetched && !zakaznikData.isFetching
            && dopravaData.fetched && !dopravaData.isFetching

            && (dopravaData.data.naPobocku ? pobockaDetail.fetched && !pobockaDetail.isFetching : true)
            && (!dopravaData.data.naPobocku && dopravaData.data.zpusobDopravaId ? zpusobDoprava.fetched && !zpusobDoprava.isFetching : true)
            && (!dopravaData.data.naPobocku && dopravaData.data.terminDopravaId ? terminDopravaDetail.fetched && !terminDopravaDetail.isFetching : true)

            && platbaData.fetched && !platbaData.isFetching
            && aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching
            && (aktivniSpolecnostId.data ? aktivniSpolecnostDetail.fetched && !aktivniSpolecnostDetail.isFetching : true)
            && uzivatelVychoziHodnotyDetail.fetched && !uzivatelVychoziHodnotyDetail.isFetching
            // pokud máme uživatele daného operátorem, musíme načíst jeho výchozí hodnoty
            && (uzivatelUrcenOperatorem ? objednavkaUzivatelVychoziHodnotyDetail.fetched && !objednavkaUzivatelVychoziHodnotyDetail.isFetching : true)
            // pokud máme uživatele daného operátorem a ten má společnost, musíme načíst její detail
            && (uzivatelSpolecnostId ? objednavkaSpolecnostDetail.fetched && !objednavkaSpolecnostDetail.isFetching : true)
            && firmaDetail.fetched && !firmaDetail.isFetching
            ;
    };

    saveData = (data) => {
        const {loggedInUser} = this.props;
        localStorageUtils.saveOrderData(loggedInUser.data.id, CURRENT_STEP, data);
        this.unsavedData = null;
    };

    invalidateAndContinue = () => {
        const {loggedInUser} = this.props;
        this.props.dispatch(objednavkaActions.invalidateDataPlatba());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastFinishedStep(loggedInUser.data.id));
        redirectToOrderStepNumber(CURRENT_STEP + 1, this.props);
    };

    render() {
        const {aktivniSpolecnostDetail, platbaData, zpusobyPlatbyList, zpusobDoprava, pobockaDetail,
            zakazkaData, zakaznikData, dopravaData, objednavkaSpolecnostDetail, firmaDetail, terminDopravaDetail,
            uzivatelVychoziHodnotyDetail, objednavkaUzivatelVychoziHodnotyDetail, t} = this.props;

        if (!this.isFetched()) {
            return <Loader/>;
        }

        const uzivatelUrcenOperatorem = !!zakaznikData.data.uzivatelASpolecnost;
        const maSpolecnost = uzivatelUrcenOperatorem ? !!zakaznikData.data.uzivatelASpolecnost.spolecnostId : !!aktivniSpolecnostDetail.data;

        const spolecnost = uzivatelUrcenOperatorem ? maSpolecnost ? objednavkaSpolecnostDetail.data : null : aktivniSpolecnostDetail.data;
        const vychoziZpusobPlatba = uzivatelUrcenOperatorem ?
            objednavkaUzivatelVychoziHodnotyDetail.data && objednavkaUzivatelVychoziHodnotyDetail.data.zpusobPlatba :
            uzivatelVychoziHodnotyDetail.data && uzivatelVychoziHodnotyDetail.data.zpusobPlatba;

        const initialValues = {
            zpusobPlatbaId: vychoziZpusobPlatba && vychoziZpusobPlatba.id ? vychoziZpusobPlatba.id.toString() : null, // radio input zatim neumí integer
            ...platbaData.data
        };

        // Pokud je povoleno přeskočení platby a existuje výchozí způsob platby, můžeme krok přeskočit
        const preskocitPlatbuPovoleno = maSpolecnost && spolecnost.preskocitPlatba;
        if (preskocitPlatbuPovoleno && vychoziZpusobPlatba.id && !platbaData.data) {
            // console.debug("Přeskakuji krok platba");
            this.saveData({...initialValues, finished: true});
            this.invalidateAndContinue();
        }

        let pobocka;
        let adresa;
        if (dopravaData.data.naPobocku) {
            pobocka = pobockaDetail.data;
        } else {
            const {ulice, obec, psc, stat} = dopravaData.data;
            adresa = {ulice, obec, psc, stat};
        }

        return <OrderPage title={t('pages.main.title')} subtitle={t('order.new')} currentStep={CURRENT_STEP}>
            <PlatbaForm
                onSubmit={data => {
                    return new Promise((resolve, reject) => {
                        if (!data.zpusobPlatbaId) {
                            const errors = {
                                _error: t('validation.payment_form_required')
                            };
                            reject(new SubmissionError(errors));
                        }
                        resolve(this.saveData({...data, finished: true}));
                    });
                }}
                onSubmitSuccess={this.invalidateAndContinue}
                onChange={(data) => this.unsavedData = data}
                initialValues={initialValues}
                zpusobyPlatbyList={zpusobyPlatbyList.rows}
                zpusobDoprava={zpusobDoprava.data}
                pobocka={pobocka}
                adresa={adresa}
                zakazkaData={zakazkaData.data}
                zakaznikData={zakaznikData.data}
                dopravaData={dopravaData.data}
                cenovaNabidka={firmaDetail.data.cenovaNabidka}
                terminDoprava={terminDopravaDetail.data}
            />
        </OrderPage>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        aktivniSpolecnostDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA),
        objednavkaSpolecnostDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
        zpusobDoprava: utils.storeFromArea(state, ciselnikActions.ZPUSOB_DOPRAVY_AREA),
        pobockaDetail: utils.storeFromArea(state, ciselnikActions.POBOCKA_AREA),
        uzivatelAdresaDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_ADRESA_AREA),
        spolecnostAdresaDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_ADRESA_AREA),
        zakazkaData: utils.storeFromArea(state, objednavkaActions.ZAKAZKA_DETAIL_AREA),
        zakaznikData: utils.storeFromArea(state, objednavkaActions.ZAKAZNIK_DETAIL_AREA),
        dopravaData: utils.storeFromArea(state, objednavkaActions.DOPRAVA_DETAIL_AREA),
        platbaData: utils.storeFromArea(state, objednavkaActions.PLATBA_DETAIL_AREA),
        firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
        terminDopravaDetail: utils.storeFromArea(state, ciselnikActions.TERMIN_DOPRAVY_AREA),
        uzivatelVychoziHodnotyDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_VYCHOZI_HODNOTY_AREA),
        objednavkaUzivatelVychoziHodnotyDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(PlatbaPage)));

